import Vue from 'vue'

import './routes/route-home.vue'
import './routes/route-atlas.vue'
import './routes/route-artist.vue'
import './routes/route-program.vue'
import './routes/route-about.vue'
import './routes/route-bulletin.vue'
import './routes/route-tags.vue'
import './routes/route-not-found.vue'

import './components/app.vue'
import './components/text-marquee.vue'
import './components/chyron.vue'
import './components/top-menu.vue'
import './components/bottom-menu.vue'
import './components/atlas.vue'
import './components/slider.vue'
import './components/slide.vue'
import './components/artist-gallery.vue'
import './components/nav-items.vue'
import './components/video-player.vue'
import './components/play-button.vue'

import './filters'

import router from './router'
import store from './store/store'

import 'intersection-observer'

import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

const app = new Vue({
  el: '#app',
  router,
  store,
  render() {
    return <app></app>
  }
})

window.app = app


// WEBPACK FOOTER //
// ./src/index.js